import React from "react";
import { useDispatch } from "react-redux";

import { updateTemplateField } from "../../../../redux/reducers/TemplateField";
import { withSelectedField } from "./withSelectedField";
import { TemplateFieldV2 } from "../../../../docuclipper/DocuclipperTypes";
import { Form } from "react-bootstrap";

type Props = {
  field: TemplateFieldV2;
};

export const _NameSelector: React.SFC<Props> = ({ field }) => {
  const dispatch = useDispatch();

  return (
    <>
      {/* <div className="h5">Name</div> */}
      <Form.Control
        name="fieldName"
        placeholder="Field name"
        value={field.name}
        onChange={(e) =>
          dispatch(
            updateTemplateField({
              id: field.id,
              update: {
                name: e.target.value,
              },
            })
          )
        }
      />
    </>
  );
};

export const NameSelector = withSelectedField(_NameSelector);
